import { ErrorListener, RecognitionException, Recognizer, Token } from 'antlr4'
import { ErrorToken } from './formula.js'

/**
 * Listener for errors from the ANTLR parser that then stores the errors so they can be passed
 * into the code mirror
 */
export class FormulaErrorListener extends ErrorListener<Token> {
  errors: ErrorToken[] = [] // Array to store error details

  public syntaxError(
    recognizer: Recognizer<Token>,
    offendingSymbol: Token,
    line: number,
    charPositionInLine: number,
    msg: string,
    e: RecognitionException | undefined,
  ): void {
    this.errors.push({
      start: offendingSymbol.start,
      end: offendingSymbol.stop + 1,
      message: msg,
      recognizer,
      line,
      charPositionInLine,
      e,
      offendingSymbol,
      // To differentiate ANTLR errors from errors that come from the formula model builder
      isBuilderError: false,
    })
  }
}
